export const UPDATE_ME = 'UPDATE_ME'
export const UPDATE_TENANT_INFO = 'UPDATE_TENANT_INFO'

export const UPDATE_THEME = 'UPDATE_THEME'
export const UPDATE_ROUTE = 'UPDATE_ROUTE' // todo 全局深色模式

export const UPDATE_AI_CHATS = 'UPDATE_AI_CHATS'
export const UPDATE_AI_REQUESTS = 'UPDATE_AI_REQUESTS'
export const ADD_AI_REQUESTS = 'ADD_AI_REQUESTS'
export const REMOVE_AI_REQUESTS = 'REMOVE_AI_REQUESTS'
export const UPDATE_AI_SWITCH = 'UPDATE_AI_SWITCH'
